export enum EApiKey {
  GET_ENTITY_IMAGE = 'GET_ENTITY_IMAGE',
  GET_NEWS_FEED = 'GET_NEWS_FEED',
}

export enum DocumentTypeCode {
  Avatar = 1,
  Banner = 2,
  Logo = 3,
  Document = 4,
  Image = 5,
}

export enum DocumentImageSize {
  'thumb' = 'thumb',
  'xs' = 'xs',
  's' = 's',
  'm' = 'm',
  'l' = 'l',
  'xl' = 'xl',
}

export const PUBLIC_SEARCH_PREFIX = '/publicSearch';
